<template>
    <div class="turn-table">
        <!-- 顶部导航 -->
        <nav-bar ref="navBar" :maxOpacity="0.5" bgColor="#000">
            <div class="nav-box">
                <img class="back" src="../../assets/images/postalNewCustomer/back.png" @click="goBack">
                <div>绿色出行 “邮”享好礼</div>
                <div class="back"></div>
            </div>
        </nav-bar>
        <!-- 右侧按钮 -->
        <button-content :showShareBtn="false" ruleName="newTurntablRule"></button-content>
        <img class="flower" src="../../assets/images/postalNewCustomer/icon_flower.png" alt="">
        <div class="texts">广告</div>
        <!-- 主功能 -->
        <div class="box">
            <div class="table-box">
                <LuckyWheel ref="LuckyWheel" :blocks="blocks" :buttons="buttons" :defaultConfig="defaultConfig" :prizes="prizes" height="91vw" width="91vw" @end="endCallBack" @start="startCallBack" />
                <div class="number-box">
                    <div class="turn-number">剩余{{ number }}次</div>
                </div>
            </div>
            <div class="margin">
                <content-item-container :showWord="true" :isCenter="true" wordPosition="center">
                    <div class="reward-list">
                        <div class="item-box margin-bottom">
                            <img class="reward-bg" src="../../assets/images/postalNewCustomer/turntable/reward_box.png">
                            <div class="reward-box padding-top">
                                <div class="reward-text">
                                    2000kcal精力值<span class="green">兑换1次</span><span class="red">（每日仅限一次）</span>
                                </div>
                                <div class="gray">{{ buttonStatus.buy }}/1</div>
                                <img v-if="buttonStatus.buy <1" class="reward-btn" src="../../assets/images/postalNewCustomer/turntable/button_exchange.png" @click="toExchange">
                                <img v-else class="reward-btn" src="../../assets/images/postalNewCustomer/turntable/button_join_after.png">
                            </div>
                        </div>
                        <div class="item-box margin-bottom">
                            <img class="reward-bg" src="../../assets/images/postalNewCustomer/turntable/reward_box.png">
                            <div class="reward-box">
                                <div class="reward-text">每邀请1位新用户注册青碳行<span class="green">可获得1次</span>
                                    <div class="red" style="margin-left:-2vw">（每日仅限三次）</div>
                                </div>
                                <div class="gray">{{ buttonStatus.invite }}/3</div>
                                <img class="reward-btn" src="../../assets/images/postalNewCustomer/turntable/button_invite.png" @click="inviteShare">
                            </div>
                        </div>
                        <div class="item-box margin-bottom">
                            <img class="reward-bg" src="../../assets/images/postalNewCustomer/turntable/reward_box.png">
                            <div class="reward-box">
                                <div class="reward-text">成功授权低碳有礼<span class="green">可获得1次机会</span>
                                </div>
                                <div class="gray">{{ buttonStatus.empower }}/1</div>
                                <img v-if="buttonStatus.empower < 1" class="reward-btn" src="../../assets/images/postalNewCustomer/turntable/button_empower.png" @click="clickEmpower">
                                <img v-else class="reward-btn" src="../../assets/images/postalNewCustomer/turntable/button_get_after.png">
                            </div>
                        </div>
                        <div class="item-box">
                            <img class="reward-bg" src="../../assets/images/postalNewCustomer/turntable/reward_box.png">
                            <div class="reward-box">
                                <div class="reward-text">报名参与活动<span class="green">可获得1次机会</span>
                                </div>
                                <div class="gray">{{ buttonStatus.join }}/1</div>
                                <img v-if="buttonStatus.join < 1" class="reward-btn" src="../../assets/images/postalNewCustomer/turntable/button_join.png" @click="toSignUp">
                                <img v-else class="reward-btn" src="../../assets/images/postalNewCustomer/turntable/button_get_after.png">
                            </div>
                        </div>
                    </div>
                </content-item-container>
            </div>
            <!-- 底部logo -->
            <bottom-logo style="margin-top:2.267vw"></bottom-logo>
        </div>
        <!-- 兑换确认弹窗 -->
        <popup :confirmShow="confirmShow" @cancelExchange="cancelExchange" @confirmExchange="confirmExchange"></popup>
        <!-- 抽奖提示弹窗 -->
        <popup :tipShow="tipShow" @closeTip="closeTip" @toSignUp="toSignUp"></popup>
        <!-- 奖励弹窗 -->
        <show-reward-modal :visible.sync="showReward" :prize-type-code="prizeTypeCode" type="get"></show-reward-modal>
        <!-- 徽章头像弹窗 -->
        <save-avatar-modal :visible.sync="showAvatar" :avatar-no="avatarNo"></save-avatar-modal>
        <!-- 地铁券弹窗 -->
        <popup :isMetroShow="isMetroShow" @closeMetro="closeMetro"></popup>
        <!-- 优惠券弹窗 -->
        <popup :isWriteOff="isWriteOff" @closeWriteOff="closeWriteOff"></popup>
    </div>
</template>

<script>
import navBar from './components/NavBar.vue'
import buttonContent from './components/ButtonContent.vue'
import contentItemContainer from './components/ContentItemContainer.vue'
import popup from './components/Popups.vue'
import { queryLeftTicket, queryTicket, queryUserInfo, luckDraw, exchange, getAuthPrize } from '../../services/modules/postalNewCustomer'
import showRewardModal from './ShowRewardModal.vue'
import saveAvatarModal from './SaveAvatarModal.vue'
import bottomLogo from './components/BottomLogo.vue'


export default {
    components: { navBar, buttonContent, contentItemContainer, popup, showRewardModal, saveAvatarModal, bottomLogo },
    data() {
        return {
            avatarNo: '',
            isWriteOff: false,//是否显示优惠券弹窗
            token: this.$store.state.user.token ? this.$store.state.user.token : sessionStorage.getItem('token'),
            deviceCoding: this.$store.state.user.deviceCoding ? this.$store.state.user.deviceCoding : sessionStorage.getItem('deviceCoding'),
            activeBaseInfoId: 114,
            confirmShow: false,//是否显示兑换确认弹窗
            tipShow: false,//是否显示抽奖提示弹窗
            buttonStatus: {
                first: true,//是否有首次优惠
                buy: 0,//兑换次数
                invite: 0,//邀请次数
                empower: 0,//授权次数
                join: 0,//参加次数
            },
            number: 0,
            time: new Date().getTime(),
            showReward: false,//是否显示弹窗
            showAvatar: false,//是否显示头像弹窗
            isMetroShow: false,//是否显示地铁券弹窗
            prizeTypeCode: '',//奖品id
            blocks: [{
                imgs: [
                    {
                        src: require('../../assets/images/postalNewCustomer/turntable/turntable_bg.png'),
                        width: '91vw',
                        height: '91vw',
                        top: 0,
                        rotate: true
                    }
                ]
            }],//背景样式修改
            prizes: [//转盘数据
                {
                    value: 1,
                    name: "地铁乘车券",
                    imgs: [{
                        src: require('../../assets/images/postalNewCustomer/turntable/reward_6.png'),
                        width: '19.333vw',
                        height: '20.4vw',
                        top: '6vw'
                    }],
                    id: 'cfa524d7-5a0d-45f8-b306-68d09aaa8087',
                    type: 'metro'
                },
                {
                    value: 2,
                    name: "商家优惠券",
                    imgs: [{
                        src: require('../../assets/images/postalNewCustomer/turntable/reward_3.png'),
                        width: '19.333vw',
                        height: '20.4vw',
                        top: '6vw'
                    }],
                    id: 'b9b4ecc6-fa81-40fb-8b3a-767a1124c71c',
                    type: 'coupon'
                },
                {
                    value: 3,
                    name: "限量帆布袋",
                    imgs: [{
                        src: require('../../assets/images/postalNewCustomer/turntable/reward_8.png'),
                        width: '19.333vw',
                        height: '20.4vw',
                        top: '6vw'
                    }],
                    id: '56db0a70-4b87-4ab5-92fe-7f0ea7eaeb82',
                    type: 'bag'
                },
                {
                    value: 4,
                    name: "联名徽章",
                    imgs: [{
                        src: require('../../assets/images/postalNewCustomer/turntable/reward_1.png'),
                        width: '19.333vw',
                        height: '20.4vw',
                        top: '6vw'
                    }],
                    id: '3e2fbb47-1a5c-49a1-b8a1-c9b844bfe572',
                    type: 'avatar'
                },
                {
                    name: "谢谢参与",
                    imgs: [{
                        src: require('../../assets/images/postalNewCustomer/turntable/reward_2.png'),
                        width: '19.333vw',
                        height: '20.4vw',
                        top: '6vw'
                    }],
                    id: 'cee4bb5f-8eec-46eb-8d59-25564bc0cbf5',
                    type: 'thanks'
                },

                {
                    name: "狮王口喷",
                    imgs: [{
                        src: require('../../assets/images/postalNewCustomer/turntable/reward_4.png'),
                        width: '19.333vw',
                        height: '20.4vw',
                        top: '6vw'
                    }],
                    id: 'cdf66805-35b5-49bf-afed-2fef676e684f',
                    type: 'koupen'
                },
                {
                    name: "狮王洗手液",
                    imgs: [{
                        src: require('../../assets/images/postalNewCustomer/turntable/reward_5.png'),
                        width: '19.333vw',
                        height: '20.4vw',
                        top: '6vw'
                    }],
                    id: '453adefe-7c54-4b4b-89ea-462f45381bca',
                    type: 'xishouye'
                },

                {
                    name: "狮王漱口水",
                    imgs: [{
                        src: require('../../assets/images/postalNewCustomer/turntable/reward_7.png'),
                        width: '19.333vw',
                        height: '20.4vw',
                        top: '6vw'
                    }],
                    id: 'acc4a21b-27e8-44bd-afbf-5001f5015c4d',
                    type: 'shukoushui'
                },
            ],
            defaultConfig: {//默认样式
                offsetDegree: 0,
            },
            buttons: [{//配置指针图片
                radius: '35px',
                imgs: [{
                    src: require('../../assets/images/postalNewCustomer/turntable/pointer_active.png'),
                    width: '23.8vw',
                    height: '29.067vw',
                    top: '-17.3vw'

                }]
            }],//指针按钮颜色
        }
    },
    computed: {},
    created() { },
    activated() {
        this.showAvatar = false
        this.getPowerReward()
    },
    deactivated() {
    },
    beforeDestroy() {
    },
    methods: {
        //关闭利达优惠券弹窗
        closeWriteOff() {
            this.isWriteOff = false
        },
        //领取地铁授权奖励
        getPowerReward() {
            getAuthPrize({ token: this.token, activeBaseInfoId: this.activeBaseInfoId }).then(res => {
                this.getLuckDrawNumber()
                this.getQualificationNumber()
                this.getInfo()
            })
        },
        //关闭地铁券弹窗
        closeMetro() {
            this.isMetroShow = false
        },
        //获取抽奖次数
        getLuckDrawNumber() {
            let jsonData = {
                activeBaseInfoId: this.activeBaseInfoId,
                token: this.token
            }
            queryLeftTicket(jsonData).then(res => {
                this.number = res.data
                if (this.number < 1) {
                    this.buttons[0].imgs[0].src = require('../../assets/images/postalNewCustomer/turntable/pointer_gray.png')
                } else {
                    this.buttons[0].imgs[0].src = require('../../assets/images/postalNewCustomer/turntable/pointer_active.png')
                }
            })
        },
        //获取登陆信息
        getInfo() {
            let jsonData = {
                activityCode: this.activeBaseInfoId,
                token: this.token
            }
            queryUserInfo(jsonData).then(res => {
                this.maskId = res.maskId || ''
                let endTime = new Date(res.ext2.replace(/-/g, '/')).getTime()
                let nowTime = new Date(res.ext3.replace(/-/g, '/')).getTime()
                this.time = endTime - nowTime
            })
        },
        //获取抽奖资格次数
        getQualificationNumber() {
            let jsonData = {
                activeBaseInfoId: this.activeBaseInfoId,
                token: this.token
            }

            queryTicket(jsonData).then(res => {
                // this.$toast('执行' + JSON.stringify(res))
                //是否为第一次优惠
                if (res.firstBuy) this.buttonStatus.first = true
                else this.buttonStatus.first = false
                //参加活动次数
                if (res.JOIN) {
                    if (res.JOIN < 2) this.buttonStatus.join = res.JOIN
                    else this.buttonStatus.join = 1
                } else this.buttonStatus.join = 0
                //兑换次数
                if (res.BUY) {
                    if (res.BUY < 2) this.buttonStatus.buy = res.BUY
                    else this.buttonStatus.buy = 1
                } else this.buttonStatus.buy = 0
                //邀请次数
                if (res.INVITE) {
                    if (res.INVITE < 4) this.buttonStatus.invite = res.INVITE
                    else this.buttonStatus.invite = 3
                } else {
                    this.buttonStatus.invite = 0
                }
                //授权次数
                if (res.METRO_AUTH) {
                    if (res.METRO_AUTH < 2) this.buttonStatus.empower = res.METRO_AUTH
                    else this.buttonStatus.empower = 1
                } else this.buttonStatus.empower = 0
            })
        },
        goBack() {
            this.$router.go(-1)
        },
        startCallBack() {
            //活动时间结束
            if (this.time < 1) {
                this.$toast('活动已结束，请期待其他活动吧~')
                return
            }
            if (!this.maskId) {
                this.tipShow = true
                return
            }

            if (this.number > 0) {
                //有抽奖次数 执行
                this.$refs.LuckyWheel.play()
                let jsonData = {
                    activeBaseInfoId: this.activeBaseInfoId,
                    token: this.token
                }
                luckDraw(jsonData).then(res => {
                    if (res.respcod == '01') {
                        setTimeout(() => {
                            let index = this.prizes.findIndex(e => { return e.id == res.data.prizeSubId })
                            this.$refs.LuckyWheel.stop(index)
                        }, 3000)
                    } else {
                        setTimeout(() => {
                            this.$refs.LuckyWheel.stop(4)
                            this.$toast(res.respmsg)
                        }, 3000)
                    }
                })
            } else {
                this.$toast('暂无抽奖次数，快去下方完成任务获取次数吧~')
                return
            }
        },
        endCallBack(prize) {
            let arr = ['coupon', 'thanks', 'avatar', 'metro']
            if (!arr.includes(prize.type)) {
                this.prizeTypeCode = prize.id
                this.showReward = true
            }
            if (prize.type == 'avatar') this.showAvatar = true
            if (prize.type == 'metro') this.isMetroShow = true
            if (prize.type == 'coupon') this.isWriteOff = true
            this.getLuckDrawNumber()
        },
        toExchange() {
            //活动时间结束
            if (this.time < 1) {
                this.$toast('活动已结束，请期待其他活动吧~')
                return
            }
            if (!this.maskId) {
                this.tipShow = true
                return
            }
            this.confirmShow = true
        },
        //邀请新用户
        inviteShare() {
            //活动时间结束
            if (this.time < 1) {
                this.$toast('活动已结束，请期待其他活动吧~')
                return
            }
            if (!this.maskId) {
                this.tipShow = true
                return
            }
            const url = process.env.VUE_APP_URL + 'postalShareIndex?source=5&maskId=' + this.maskId
            if (this.$store.state.app.system === "ios") {
                let message = {
                    url,         //分享出去的URL
                    title: '绿色出行 “邮”享好礼',        //分享出去的标题
                    content: '青碳行&中国邮储银行青岛市分行举办，最高可得88.88元数字人民币。',      //分享出去的描述
                    isImageOnly: "0",  //是否为图片分享,"1"表示true ‘0’表示false
                    imageUrl: 'https://carbon.lcago.cn/file/202210/11/d303f489421650a935235d0328120ec1e4255e1e5ded4569c1ace5d5be008fa8.png', //普通分享中必须使用该字段；分享图片的URL
                    imageBase64: '',  //分享图片的base64,imageUrl优先级高于base64
                    saveable: "0",     //是否支持保存本地，保存本地的图片使用imageUrl或者imageBase64字段，"1"表示true ‘0’表示false
                    copyable: "1",     //是否支持复制链接，"1"表示true ‘0’表示false
                    copyLink: "",     //复制链接的URL,如果不存在，默认使用url
                    callBack: "shareEnd", //操作的返回
                    posterUrl: '',
                    copyUrl: '0'
                }
                window.webkit.messageHandlers.QTX_H5_SHARE.postMessage(message)

            } else if (this.$store.state.app.system === "android") {
                let jsonParam = {
                    type: 1, //分享类型：1链接 2图片Url 3图片Base64
                    needSavePic: false, //是否显示保存本地
                    needCopyLink: true, //是否显示拷贝链接
                    title: '绿色出行 “邮”享好礼', //标题
                    desc: '青碳行&中国邮储银行青岛市分行举办，最高可得88.88元数字人民币。', //描述
                    url, //链接
                    thumb: 'https://carbon.lcago.cn/file/202210/11/d303f489421650a935235d0328120ec1e4255e1e5ded4569c1ace5d5be008fa8.png', //分享链接时的缩略图
                    base64Pic: '', //图片Base64
                }
                window.CarbonWebView.appShare(JSON.stringify(jsonParam), 'shareEnd')
            }
        },
        //去授权
        clickEmpower() {
            //活动时间结束
            if (this.time < 1) {
                this.$toast('活动已结束，请期待其他活动吧~')
                return
            }
            if (!this.maskId) {
                this.tipShow = true
                return
            }
            const url = process.env.VUE_APP_METRO + 'metroCoupons'
            window.location.href = url
        },
        //确认兑换
        confirmExchange() {
            //活动时间结束
            if (this.time < 1) {
                this.$toast('活动已结束，请期待其他活动吧~')
                return
            }
            if (!this.maskId) {
                this.tipShow = true
                return
            }
            let jsonData = {
                token: this.token,
                deviceCoding: this.deviceCoding,
                activeBaseInfoId: this.activeBaseInfoId,
            }
            exchange(jsonData).then(res => {
                this.confirmShow = false
                if (res && res.respcod == '01') {
                    setTimeout(() => {
                        this.getQualificationNumber()
                        this.getLuckDrawNumber()
                    }, 500)
                } else if (res && res.respcod == '02' && res.data == -1) {
                    this.$toast('精力值不足，快去“至臻社区”获取精力值吧～')
                } else this.$toast(res.respmsg)
            })
        },
        //取消兑换
        cancelExchange() {
            this.confirmShow = false
        },
        //关闭抽奖提示弹窗
        closeTip() {
            this.tipShow = false
        },
        //去报名
        toSignUp() {
            this.tipShow = false
            this.$router.go(-1)
        }
    },
}
</script>

<style lang="scss" scoped>
@function pxvw($px) {
    @return ($px / 750) * 100 * 1vw;
}
.nav-box {
    width: 100vw;
    padding: 0 pxvw(30);
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-size: pxvw(32);
    height: 10.333vw;
    .back {
        width: pxvw(34);
        height: pxvw(34);
    }
}
.turn-table {
    background: #9ae6b0;
    position: relative;
    .flower {
        position: absolute;
        width: pxvw(132);
        height: pxvw(132);
        right: pxvw(20);
        top: pxvw(1280);
    }
    .texts {
        position: absolute;
        top: 17vw;
        left: 2vw;
        font-size: 2.667vw;
        color: #fff;
    }
    .box {
        background: url("../../assets/images/postalNewCustomer/turntable/turntable_bg_1.jpg")
            0 0 no-repeat;
        background-size: 100%;
        min-height: 100vh;
        padding-bottom: pxvw(70);
        .table-box {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: relative;
            padding-top: pxvw(620);

            .number-box {
                position: absolute;
                top: pxvw(1068);
                left: pxvw(31.5);
                width: pxvw(682);
                display: flex;
                align-items: center;
                justify-content: center;

                .turn-number {
                    background: #7558f4; /* 针对不支持渐变的浏览器 */
                    background: -webkit-linear-gradient(left, #ce6cf7, #7558f4);
                    height: pxvw(52);
                    padding: 0 pxvw(23);
                    border-radius: pxvw(100);
                    color: #fff;
                    font-size: pxvw(28);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-top: pxvw(2);
                }
            }
        }
        .margin {
            margin-top: pxvw(111);
            .reward-list {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding: pxvw(55) 0;

                .item-box {
                    position: relative;

                    &.margin-bottom {
                        margin-bottom: pxvw(20);
                    }

                    .reward-bg {
                        width: pxvw(622);
                        display: block;
                        font-size: 0;
                    }

                    .reward-box {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &.padding-top {
                            padding-top: pxvw(20);
                        }

                        .reward-text {
                            width: pxvw(260);
                            font-size: pxvw(26);
                            color: #5c5c5c;

                            .green {
                                color: #27bbb5;
                            }

                            .red {
                                font-size: pxvw(21);
                                color: #ff7979;
                            }
                        }

                        .gray {
                            color: #a5a5a5;
                            font-size: pxvw(30);
                            margin: 0 pxvw(20) 0 pxvw(30);
                        }

                        .reward-btn {
                            width: pxvw(170);
                        }
                    }

                    .reward-title {
                        position: absolute;
                        top: pxvw(-11);
                        left: pxvw(10);
                        width: pxvw(364);
                    }
                }
            }
        }
    }
}
</style>